// @flow

import SharedColors from 'frontend_core/dist/styles/colors'

export default Object.assign(SharedColors, {
  sublink: '#000', // ゆくゆく削除
  notesColor: '#a0a0a0',

  stayBlue: '#21a8b4', // ゆくゆく削除
  stayLightBlue: '#2ab3c0', // ゆくゆく削除
})



// WEBPACK FOOTER //
// ./src/components/styles/colors.js